import { useAccountTypeStructures } from "@features/tickets/shared/hooks/useAccountTypeStructures";
import { WORK_STRUCTURE_TYPE } from "./works.constants";

export function useWorkStructures() {
  return useAccountTypeStructures(WORK_STRUCTURE_TYPE);
}
